import React, { useEffect, useState } from 'react';
import { Container, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth, db } from '../services/firebase';
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { collection, addDoc } from 'firebase/firestore';

// Add function to log login confirmations
const logLoginConfirmation = async (email: string, success: boolean) => {
  try {
    const loginLogsRef = collection(db, 'loginLogs');
    await addDoc(loginLogsRef, {
      email,
      timestamp: new Date().toISOString(),
      success,
      type: 'confirmation'
    });
  } catch (error) {
    console.error('Error logging login confirmation:', error);
  }
};

export default function LoginConfirm() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const completeSignIn = async () => {
      try {
        const currentUrl = window.location.href;
        
        if (isSignInWithEmailLink(auth, currentUrl)) {
          let email = window.localStorage.getItem('emailForSignIn');
          
          if (!email) {
            // If email is not saved in localStorage, prompt user
            email = window.prompt('Please provide your email for confirmation');
          }
          
          if (email) {
            await signInWithEmailLink(auth, email, currentUrl);
            await logLoginConfirmation(email, true);
            window.localStorage.removeItem('emailForSignIn');
            navigate('/dashboard');
          } else {
            await logLoginConfirmation('unknown', false);
            setError('No email provided for sign in.');
          }
        } else {
          setError('Invalid sign in link.');
        }
      } catch (err) {
        console.error('Error during sign in:', err);
        const email = window.localStorage.getItem('emailForSignIn') || 'unknown';
        await logLoginConfirmation(email, false);
        setError(err instanceof Error ? err.message : 'An error occurred during sign in');
      }
    };

    completeSignIn();
  }, [navigate]);

  if (error) {
    return (
      <Container style={{ maxWidth: '600px', marginTop: '50px' }}>
        <Alert variant="danger">
          <Alert.Heading>Error completing sign in</Alert.Heading>
          <p>{error}</p>
        </Alert>
      </Container>
    );
  }

  return (
    <Container style={{ maxWidth: '600px', marginTop: '50px', textAlign: 'center' }}>
      <Spinner animation="border" role="status" />
      <p className="mt-3">Completing sign in...</p>
    </Container>
  );
} 